import React from "react";
import { CalendarBox } from "../../containers";

export const CalendarPage = () => {
  return (
    <div>
      <CalendarBox />
    </div>
  );
};
